import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { initialState } from "./slice";

const interactionSlice = (state: RootState) =>
  state.interactions || initialState;

export const selectInteractions = createSelector(
  [interactionSlice],
  (state) => state.interactions
);

export const selectActiveInteractionId = createSelector(
  [interactionSlice],
  (state) => state.activeInteractionId
);

export const selectedInteractionRequestModelOpen = createSelector(
  [interactionSlice],
  (state) => state.interactionRequestModelOpen
);

export const isRequestButtonDisabled = createSelector(
  [interactionSlice],
  (state) => state.isRequestButtonDisabled
);

export const selectMessageSendInProgress = createSelector(
  [interactionSlice],
  (state) => state.messageSendInProgress
);
